var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// helpers
import { isEmpty } from '@/helpers/utils';
// includes
import { initiateUnauthorizedRequestLogout } from '@/includes/api/auth/logout';
import { isUnauthenticatedApi } from '@/includes/api/helpers';
const defaultHeaders = {
    'Content-Type': 'application/json',
};
const defaultConfig = {};
export var RequestMethod;
(function (RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["DELETE"] = "DELETE";
})(RequestMethod || (RequestMethod = {}));
export class HttpClientResponseError extends Error {
    /* istanbul ignore next */
    constructor(message, response) {
        super(message);
        this.name = 'HttpClientResponseError';
        this.response = response;
    }
}
class HttpClient {
    static get(url, params = {}, headers = {}, config = {}, queryParams = {}) {
        return new HttpClient({
            method: RequestMethod.GET,
            headers,
            config,
        }).request(url, params, queryParams);
    }
    static post(url, params = {}, headers = {}, config = {}, queryParams = {}) {
        return new HttpClient({
            method: RequestMethod.POST,
            headers,
            config,
        }).request(url, params, queryParams);
    }
    static delete(url, params = {}, headers = {}, config = {}) {
        return new HttpClient({
            method: RequestMethod.DELETE,
            headers,
            config,
        }).request(url, params);
    }
    constructor({ method, headers, config, }) {
        // Handling HTTP error statuses
        this.checkResponseStatus = (response) => {
            if (response.ok) {
                return this.handleSuccessResponse(response);
            }
            else {
                if (response.status === 401 &&
                    !isUnauthenticatedApi(response.url)) {
                    initiateUnauthorizedRequestLogout();
                }
                throw new HttpClientResponseError(response.statusText, response);
            }
        };
        this.handleSuccessResponse = (response) => {
            return this.parseJSON(response);
        };
        this.handleErrorResponse = (err, requestOptions) => {
            /* istanbul ignore next */
            if (__DEV__) {
                // tslint:disable-next-line
                console.warn(err);
            }
            console.error(err, {
                url: requestOptions.url,
                params: requestOptions.params,
                method: this.method,
            });
            // Catch the response and save
            // catchErrorResponse(err, {
            //     url: requestOptions.url,
            //     params: requestOptions.params,
            //     method: this.method,
            // });
            return Promise.reject(err);
        };
        this.method = method;
        this.headers = new Headers(Object.assign(Object.assign({}, defaultHeaders), headers));
        this.config = Object.assign(Object.assign({}, defaultConfig), config);
    }
    request(rawUrl_1) {
        return __awaiter(this, arguments, void 0, function* (rawUrl, data = {}, queryParams = {}) {
            const url = this.getFetchUrl(rawUrl, data, queryParams);
            const options = this.getFetchOptions(data);
            const controller = new AbortController();
            const signal = controller.signal;
            setTimeout(() => controller.abort(), HttpClient.REQUEST_TIMEOUT);
            try {
                const response = yield fetch(url, Object.assign({ signal }, options));
                const res = yield this.checkResponseStatus(response);
                // Check error response and catch
                // if (isErrorResponse(res)) {
                //     catchErrorResponse(res as Error, {
                //         url: rawUrl,
                //         params: data,
                //         method: this.method,
                //     });
                // }
                return res;
            }
            catch (err) {
                return this.handleErrorResponse(err, {
                    url: rawUrl,
                    params: data,
                });
            }
        });
    }
    getFetchUrl(url, data, queryParams = {}) {
        if (this.method === RequestMethod.GET && !isEmpty(data)) {
            return url + this.getQueryParams(url, data);
        }
        if (this.method === RequestMethod.POST && !isEmpty(queryParams)) {
            return url + this.getQueryParams(url, queryParams);
        }
        return url;
    }
    getQueryParams(url, queryParams) {
        return ((url.indexOf('?') === -1 ? '?' : '&') +
            this.toQueryParams(queryParams));
    }
    getFetchOptions(data) {
        const options = {
            headers: this.headers,
            method: this.method,
            mode: 'cors',
        };
        if (this.method !== RequestMethod.GET) {
            options.body = this.getRequestData(data);
        }
        return Object.assign(Object.assign({}, options), this.config);
    }
    getRequestData(data) {
        if (this.isJsonRequest()) {
            return JSON.stringify(data);
        }
        return data;
    }
    toQueryParams(params) {
        return Object.keys(params)
            .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
            .join('&');
    }
    isJsonRequest() {
        return this.headers.get('content-type') === 'application/json';
    }
    parseJSON(response) {
        return response.json();
    }
}
HttpClient.REQUEST_TIMEOUT = 15000;
export default HttpClient;
